import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearDrawerAlert, setDrawer, setOnClose } from 'slices/drawer'
import { WHITOUT_OUTSIDE_CLICK_DRAWERS, DRAWER_KEY } from 'app-constants'
import { Alert } from 'components/alert'
import { DrawerModal } from 'components/drawer-modal'
import { DrawerHeader } from '../drawer-header'
import { DrawerTemplate } from './templates'
import './style.scss'

export function Drawer() {
  const [isOpen, setIsOpen] = useState(false)
  const { key, alert, onClose, modal, headerVisibility } = useSelector(({ drawer }) => drawer)
  const dispatch = useDispatch()

  useEffect(() => {
    setIsOpen(!!key)
  }, [key])

  function handleCloseDrawer() {
    if (onClose) onClose()

    dispatch(setDrawer(DRAWER_KEY.NONE))
    dispatch(setOnClose(null))
  }

  function handleOverlayClick() {
    const shouldStayOpen = WHITOUT_OUTSIDE_CLICK_DRAWERS.includes(key)

    if (!shouldStayOpen) handleCloseDrawer()
  }

  function handleCloseAlert() {
    dispatch(clearDrawerAlert())
  }

  function renderHeader() {
    if (!headerVisibility) return null

    return <DrawerHeader onClose={handleCloseDrawer} />
  }

  return (
    <>
      <div
        className={`drawer-component ${headerVisibility ? '' : 'no-header'} ${
          isOpen ? '-open' : ''
        }`}
        data-testid='drawer-component'
      >
        {renderHeader()}
        <div className='content'>
          {!!modal && <DrawerModal modal={modal} />}
          {!!alert && <Alert className='alert' {...alert} onClose={handleCloseAlert} />}
          {DrawerTemplate()[key]}
        </div>
      </div>
      {isOpen && <div className='drawer-overlay' onClick={handleOverlayClick} />}
    </>
  )
}
